import React from "react";
import {
  getDesktopAppStatus,
  WEB2DESK_PAYMENT_REDIRECT_URL
} from "../../../api";
import Track from "../../../track";
import Payment from "../../../payment";
class DownloadApp extends React.Component {
  state = {
    loading: true,
    response: {},
    installerEnabled: false,
    sourcecodeEnabled: false
    // status: {"status":true,"appId":"VF6nOx9Fm7p1hXjJCdEn","platforms":{"linux":false,"osx":false,"windows":false}}
  };
  componentDidMount() {
    this.checkStatus();
  }
  payment = new Payment({ onSuccess: console.log });
  handleCheckBox = key => e => {
    switch (key) {
      case "installerEnabled":
        Track.event({
          category: "Premium",
          action: "installerEnabled",
          label: e.target.checked.toString()
        });
        break;
      case "sourcecodeEnabled":
        Track.event({
          category: "Web2Desk",
          action: "sourcecodeEnabled",
          label: e.target.checked.toString()
        });
        break;

      default:
        break;
    }
    this.setState({ [key]: e.target.checked });
  };
  processPayment = () => {
    if (this.state.installerEnabled && this.state.sourcecodeEnabled)
      this.payment.setProduct({
        name: "Web2desk Source Code and Installer",
        price:
          window.appmakerProducts.web2DeskInstallerPrice +
          window.appmakerProducts.web2DeskSourceCodePrice
      });
    else if (this.state.installerEnabled)
      this.payment.setProduct({
        name: "Web2desk Installer",
        price: window.appmakerProducts.web2DeskInstallerPrice
      });
    else if (this.state.sourcecodeEnabled)
      this.payment.setProduct({
        name: "Web2desk Source Code",
        price: window.appmakerProducts.web2DeskSourceCodePrice
      });

    this.payment.checkout({
      extranalRef: this.props.match.params.appId,
      redirectUrl: WEB2DESK_PAYMENT_REDIRECT_URL
    });
  };
  checkStatus = () => {
    getDesktopAppStatus({ appId: this.props.match.params.appId })
      .then(response => {
        let status = true;
        Object.keys(response.platforms).map(platform => {
          let platform_data = response.platforms[platform];
          status = status && platform_data.build_status;
          return platform;
        });
        if (!status) {
          setTimeout(() => {
            this.checkStatus();
          }, 5000);
        }
        this.setState({
          loading: false,
          response
        });
      })
      .catch(console.log);
  };

  render() {
    return (
      <section className="generator-step-1 web2desk-generator container-fluid">
        {this.state.loading ? (
          <div className="step-1 text-center active mt-5">
            <img
              className=" text-white m-auto"
              alt="Loading"
              src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/apploader-optimised.gif"
            />
            <h5>App is building</h5>
          </div>
        ) : (
          <div className="step-1 col-lg-7 col-sm-12 m-auto active">
            <div className="step-3 col-sm-12 container m-auto">
              <h3 className="text-center">Your App is ready to download</h3>
              {(window.location.search.match('payment_status=true')) && <div class="alert alert-success mt-4">
                <strong>Success!</strong> Payment is successful, We'll email you once its ready 
              </div>}
              {this.state.response.platforms.osx && (
                <div className="app-download-web d-flex item-osx">
                  <div className="apple-icon bg-success">
                    <i className="fab fa-apple" />
                  </div>

                  <h4 className="my-auto">{this.state.response.appname}</h4>
                  {this.state.response.platforms.osx.build_status ? (
                    <a
                      href={this.state.response.platforms.osx.downloadUrl}
                      className="btn btn-dark text-white my-auto ml-auto"
                    >
                      <i className="fas fa-download mr-2 ml-2" />
                    </a>
                  ) : (
                    <img
                      className=" text-white mr-0 ml-auto d-sm-block"
                      alt="Loading"
                      src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/apploader-optimised.gif"
                      style={{ width: "10%", height: "10%" }}
                    />
                  )}
                </div>
              )}
              {this.state.response.platforms.windows && (
                <div className="app-download-web d-flex item-windows">
                  <div className="windows-icon bg-success">
                    <i className="fab fa-windows" />
                  </div>

                  <h4 className="my-auto">{this.state.response.appname}</h4>
                  {this.state.response.platforms.windows.build_status ? (
                    <a
                      href={this.state.response.platforms.windows.downloadUrl}
                      className="btn btn-dark text-white my-auto ml-auto"
                    >
                      <i className="fas fa-download mr-2 ml-2" />
                    </a>
                  ) : (
                    <img
                      className=" text-white mr-0 ml-auto d-sm-block"
                      alt="Loading"
                      src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/apploader-optimised.gif"
                      style={{ width: "10%", height: "10%" }}
                    />
                  )}
                </div>
              )}
              {this.state.response.platforms.linux && (
                <div className="app-download-web d-flex item-linux">
                  <div className="linux-icon bg-success">
                    <i className="fab fa-linux" />
                  </div>

                  <h4 className="my-auto">{this.state.response.appname}</h4>
                  {this.state.response.platforms.linux.build_status ? (
                    <a
                      href={this.state.response.platforms.linux.downloadUrl}
                      className="btn btn-dark text-white ml-auto my-auto d-sm-block"
                    >
                      <i className="fas fa-download mr-2 ml-2" />
                    </a>
                  ) : (
                    <img
                      className=" text-white mr-0 ml-auto d-sm-block"
                      alt="Loading"
                      src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/apploader-optimised.gif"
                      style={{ width: "10%", height: "10%" }}
                    />
                  )}
                </div>
              )}{" "}
              <h4 className="mb-4 mt-5">Get more of your app</h4>
              <div className="form-check web2desk-installer mb-3">
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={this.state.installerEnabled}
                    onChange={this.handleCheckBox("installerEnabled")}
                  />
                  <span className="font-weight-bold">Installer</span> (DMG for mac){" "}
                  <span className="badge badge badge-success">
                    +${window.appmakerProducts.web2DeskInstallerPrice}
                  </span>
                </label>
              </div>
              <div className="form-check web2desk-sourcecode mb-3">
                <label className="form-check-label">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={this.state.sourcecodeEnabled}
                    onChange={this.handleCheckBox("sourcecodeEnabled")}
                  />
                  <span className="font-weight-bold">Soure code</span>{" "}
                  <span className="badge badge badge-success">
                    +${window.appmakerProducts.web2DeskSourceCodePrice}
                  </span>
                </label>
              </div>
              {/* <p className="mb-4">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
              </p> */}
              <button
                className="btn btn-success w-100"
                onClick={this.processPayment}
              >
                Make payment
              </button>
            </div>
          </div>
        )}
      </section>
    );
  }
}

export default DownloadApp;
